import { useController, useFormContext } from 'react-hook-form';
import RadioInput from '@components/common/radioInput';
import classnames from 'classnames/bind';
import styles from '../join.module.scss';
const cx = classnames.bind(styles);

const GenderFlag = ({ prefixName }: HookFormProps) => {
  const { trigger } = useFormContext();
  const { field } = useController({
    name: prefixName,
    defaultValue: null,
  });
  const flagValue = field.value;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(e.target.value);
    trigger('birthDate');
  };

  return (
    <div className={cx('genderFlag')}>
      <RadioInput name="MALE" label="남자" value="MALE" checked={flagValue === 'MALE'} onChange={handleChange} />
      <RadioInput name="FEMAL" label="여자" value="FEMALE" checked={flagValue === 'FEMALE'} onChange={handleChange} />
    </div>
  );
};

export default GenderFlag;
